export default {
  hubTitle: 'Cash & Accounting Settings',
  hubBadge: 'Treasury & Ledger Hub',
  hubDescription: 'Manage branch cash drawers, map QuickBooks Chart of Accounts, and verify live balances.',
  tabs: {
    cashBooks: 'CRM Cash Books',
    cashBoxes: 'CRM Cash Books',
    qboAccounts: 'QuickBooks Accounts',
    payees: 'Payees',
  },
  cashBooks: {
    title: 'Branch Cash Books',
    badge: 'Treasury & Cash Book Control',
    description: 'Manage cash books across all branches and link them directly to QuickBooks Asset accounts.',
    totalBoxes: 'Total Cash Books',
    linkedCount: 'Linked to QBO',
    unlinkedCount: 'Unlinked',
    openBoxes: 'Open Shifts',
    columns: {
      seq: '#',
      branch: 'Branch & Code',
      city: 'City',
      drawerBalance: 'Cash Book Balance (CRM)',
      dayStatus: 'Daily Status',
      mappedQbo: 'Mapped QuickBooks Account',
      qboBalance: 'QBO Live Balance',
      variance: 'Variance (Discrepancy)',
      active: 'Active in CRM',
      actions: 'Actions',
      editBook: 'Edit Cash Book & Branch',
      linkQbo: 'Link QBO Account',
      unlinked: '— Not Linked',
      balanced: 'Balanced',
      open: 'Open',
      closed: 'Closed',
    },
    dialog: {
      mapTitle: 'Link Cash Book to QuickBooks: {name}',
      mapDesc: 'Select the matching QuickBooks Bank/Cash account where daily transactions for this branch are recorded.',
      selectAccount: 'Select QuickBooks Cash Account',
      selectAccountPlaceholder: 'Choose an Asset / Bank account...',
      searchAccount: 'Search account name or #code...',
      unlink: 'Unlink Account',
      save: 'Save Mapping',
      saving: 'Saving...',
      success: 'Cash book mapping updated successfully.',
      noAccount: 'No matching accounts found.',
      activeLabel: 'Active in CRM',
      activeHint: 'Can cashiers record payments and expenses into this cash book?',
      cancel: 'Cancel',
    },
    editDialog: {
      title: 'Edit Cash Book: {name}',
      desc: 'Change the branch mapping, cash book name, code, city, and connected QuickBooks account.',
      branchLabel: 'Assigned Branch',
      branchPlaceholder: 'Select branch...',
      nameLabel: 'Cash Book Name',
      codeLabel: 'Cash Book Code',
      cityLabel: 'City / Location',
      qboAccountLabel: 'QuickBooks Cash Account',
      activeLabel: 'Active in CRM',
      activeHint: 'Can cashiers record payments and expenses into this cash book?',
      save: 'Save Changes',
      saving: 'Saving...',
      cancel: 'Cancel',
      success: 'Cash book updated successfully.',
      branchRequired: 'Please select an assigned branch.',
    },
  },
  cashBoxes: {
    title: 'Branch Cash Drawers',
    badge: 'Treasury & Drawer Control',
    description: 'Manage physical cash boxes across all branches and link them directly to QuickBooks Asset accounts.',
    totalBoxes: 'Total Cash Boxes',
    linkedCount: 'Linked to QBO',
    unlinkedCount: 'Unlinked',
    openBoxes: 'Open Shifts',
    columns: {
      seq: '#',
      branch: 'Branch & Code',
      city: 'City',
      drawerBalance: 'Drawer Balance (CRM)',
      dayStatus: 'Daily Status',
      mappedQbo: 'Mapped QuickBooks Account',
      qboBalance: 'QBO Live Balance',
      variance: 'Variance (Discrepancy)',
      active: 'Active in CRM',
      actions: 'Actions',
      linkQbo: 'Link QBO Account',
      unlinked: '— Not Linked',
      balanced: 'Balanced',
      open: 'Open',
      closed: 'Closed',
    },
    dialog: {
      mapTitle: 'Link CashBox to QuickBooks: {name}',
      mapDesc: 'Select the matching QuickBooks Bank/Cash account where daily transactions for this branch are deposited.',
      selectAccount: 'Select QuickBooks Cash Account',
      selectAccountPlaceholder: 'Choose an Asset / Bank account...',
      searchAccount: 'Search account name or #code...',
      unlink: 'Unlink Account',
      save: 'Save Mapping',
      saving: 'Saving...',
      success: 'Cash box mapping updated successfully.',
      noAccount: 'No matching accounts found.',
      activeLabel: 'Active in CRM',
      activeHint: 'Can cashiers record payments and expenses into this cash drawer?',
      cancel: 'Cancel',
    },
  },
  title: 'QuickBooks Accounts',
  badge: 'Chart of Accounts · CRM Hub',
  description: 'Manage and map Persian/Dari account names and monitor live QuickBooks balances for 124 accounts.',
  sync: 'Sync from QuickBooks',
  syncing: 'Syncing...',
  syncSuccess: 'Sync completed',
  syncSuccessDesc: '{count} accounts synced from QuickBooks successfully.',
  syncError: 'QuickBooks Sync Error',
  addManual: 'Add Manual Account',
  totalAccounts: 'Total Accounts',
  mapped: 'Mapped',
  unmapped: 'Unmapped',
  liveConnected: 'Live QBO Connected',
  classes: {
    all: 'All Accounts',
    asset: 'Assets (Asset)',
    liability: 'Liabilities (Liability)',
    equity: 'Equity',
    expense: 'Expenses (Expense)',
    revenue: 'Revenue',
    accountsCount: '{count} accounts',
  },
  filters: {
    searchPlaceholder: 'Search name, QBO ID, key...',
    mappedStatus: 'Persian Name Status',
    allMapped: 'All (Persian Name)',
    onlyMapped: 'With Persian Name (Mapped)',
    onlyUnmapped: 'Without Persian Name (Needs Mapping)',
    balanceStatus: 'Balance Status',
    allBalances: 'All Accounts (Balance)',
    hasBalance: 'Non-zero Balance',
    zeroBalance: 'Zero Balance',
    crmStatus: 'CRM Status',
    allCrm: 'All Status in CRM',
    activeCrm: 'Active in CRM Only',
    inactiveCrm: 'Inactive in CRM',
    clearFilters: 'Clear Filters',
  },
  columns: {
    seq: '#',
    qboId: 'QBO Code',
    name: 'QuickBooks Name',
    nameFa: 'Persian Name in CRM',
    classification: 'Classification',
    accountType: 'Account Type',
    currentBalance: 'Live Balance',
    categoryKey: 'System Key',
    isActiveInCrm: 'Active in CRM',
    copySuccess: 'Account ID copied',
    addPersianName: 'Add Persian Name',
    editAccount: 'Edit Account Mapping',
    refreshBalance: 'Fetch Live Balance',
    balanceUpdated: 'Balance updated',
  },
  dialog: {
    editTitle: 'Edit Account Mapping: {name}',
    qboCode: 'QBO Code',
    classification: 'Classification',
    nameFaLabel: 'Persian / Dari Name (Displayed in CRM)',
    nameFaPlaceholder: 'e.g. Wages and Salaries, Office Rent, Generator Fuel...',
    nameFaHint: 'This name will be displayed in payment vouchers, expense reports, and cashbox.',
    categoryKeyLabel: 'System Category Key',
    categoryKeyPlaceholder: 'e.g. wages_salaries, office_rent, fuel...',
    activeInCrmLabel: 'Active in CRM System',
    activeInCrmHint: 'Can this account be selected in CRM cash/payment forms?',
    allowedInVoucher: 'Allowed in Payment Voucher',
    allowedInVoucherDesc: 'Selectable in Payment Voucher',
    allowedInExpense: 'Allowed in Expense Report',
    allowedInExpenseDesc: 'Selectable in Expense Report',
    descriptionLabel: 'Internal Notes & Description',
    descriptionPlaceholder: 'Optional internal notes...',
    cancel: 'Cancel',
    save: 'Save Changes',
    saving: 'Saving...',
    createTitle: 'Add New Account in CRM',
    createDesc: 'Enter account details matching QuickBooks for CRM use.',
    nameEnLabel: 'QuickBooks Account Name (English)',
    nameEnPlaceholder: 'e.g. Generator Repair Expense',
    currencyLabel: 'Currency',
    afn: 'Afghani (AFN)',
    usd: 'US Dollar (USD)',
    create: 'Create Account',
    creating: 'Creating...',
    statusUpdated: 'Status updated',
    statusUpdatedDesc: 'Account {name} is now {status} in CRM forms.',
  },
};
